// Artisan Bites — full HORECA catalogue data
// Sourced from the HORECA_COLLECTION_UPDATED catalogue PDF

export const HORECA_CATALOGUE = [
  {
    id: "filled-cookies",
    category: "Signature Filled Cookies",
    index: "01",
    format: "Frozen · Bake-off",
    description:
      "Soft-baked shells hiding molten, gooey cores. Developed for hotel and restaurant pass service — bake from frozen in minutes.",
    image: "/products/filled-cookiese.jpg",
    tags: ["frozen", "bake-off", "cookies", "sweet", "signature"],
    products: [
      {
        name: "Original New York Style Cookie",
        desc: "A soft-baked cookie hiding a molten salted-caramel core. Generously sized and endlessly popular.",
        format: "Frozen",
        serves: "Individual",
      },
      {
        name: "Milk Chocolate New York Style Cookie",
        desc: "Chocolate-filled indulgence with a slow, gooey centre and a crisp chocolate-chip edge.",
        format: "Frozen",
        serves: "Individual",
      },
      {
        name: "Salted Caramel Twix Cookie",
        desc: "Buttery cookie dough layered with salted caramel and a milk chocolate filling.",
        format: "Frozen",
        serves: "Individual",
      },
    ],
  },
  {
    id: "cookie-pots",
    category: "Individual Cookie Pots",
    index: "02",
    format: "Frozen · Bake-off",
    description:
      "Warm, gooey and served straight from the oven in individual ramekins. A show-stopping dessert that guests love to photograph.",
    image: "/products/cookie-pots.jpg",
    tags: ["frozen", "bake-off", "cookies", "sweet", "pot", "individual"],
    products: [
      {
        name: "Classic Cookie Pot",
        desc: "The signature soft-baked cookie dough, baked to order and served warm and gooey in its own pot.",
        format: "Frozen",
        serves: "Individual",
      },
      {
        name: "Triple Chocolate Cookie Pot",
        desc: "Three chocolates — dark, milk and white — folded through a molten, spoonable chocolate centre.",
        format: "Frozen",
        serves: "Individual",
      },
    ],
  },
  {
    id: "desserts",
    category: "Individual Desserts",
    index: "03",
    format: "Chilled",
    description:
      "Plated-quality desserts, individually portioned for consistent service. Chilled and ready to plate — pastry-chef finish without the labour.",
    image: "/products/desserts.jpg",
    tags: ["chilled", "plated", "dessert", "individual", "sweet"],
    products: [
      {
        name: "San Sebastián Cheesecake Cup",
        desc: "Burnt-top Basque cheesecake — caramelised, creamy and served in a premium cup.",
        format: "Chilled",
        serves: "Individual",
      },
      {
        name: "Le Chocolat Parisien",
        desc: "Dark chocolate mousse with a deep cocoa finish and a silky, aerated texture.",
        format: "Chilled",
        serves: "Individual",
      },
      {
        name: "Classic Tiramisu",
        desc: "Espresso-soaked sponge, layered with smooth mascarpone and dusted with fine cocoa.",
        format: "Chilled",
        serves: "Individual",
      },
      {
        name: "Sticky Toffee Pudding",
        desc: "Moist date sponge drenched in a warm toffee sauce. A beloved British classic, perfected.",
        format: "Chilled",
        serves: "Individual",
      },
      {
        name: "Coconut, Mango & Passionfruit",
        desc: "Tropical layers of coconut cream, mango compote and passionfruit curd — bright and clean.",
        format: "Chilled",
        serves: "Individual",
      },
      {
        name: "Banana Pudding",
        desc: "Nostalgic layers of vanilla custard, fresh banana and buttery crumb. Crowd-pleasing and seasonal.",
        format: "Chilled",
        serves: "Individual",
      },
    ],
  },
  {
    id: "cakes-loaves",
    category: "Cakes & Loaves",
    index: "04",
    format: "Ambient",
    description:
      "Whole cakes and sliceable loaves that arrive ready to slice and serve. Perfect for breakfast buffets, afternoon tea and café counters.",
    image: "/products/cakes-loaves.jpg",
    tags: ["ambient", "cake", "loaf", "slice", "breakfast", "afternoon tea"],
    products: [
      {
        name: "Classic Banana Bread",
        desc: "Dense, moist and generously spiced — the definitive banana loaf for café counters.",
        format: "Ambient",
        serves: "Loaf / Slices",
      },
      {
        name: "Lemon Cake",
        desc: "Zesty tender crumb with a bright citrus glaze and a generous lemon drizzle finish.",
        format: "Ambient",
        serves: "Cake / Slices",
      },
      {
        name: "Vanilla Latte Streusel Cake",
        desc: "Coffee-kissed sponge layered under a buttery, crumbly streusel topping.",
        format: "Ambient",
        serves: "Cake / Slices",
      },
    ],
  },
  {
    id: "savoury",
    category: "Savoury Bakery",
    index: "05",
    format: "Frozen · Bake-off",
    description:
      "Golden, herbed and shareable bakes. Versatile across breakfast, brunch and snack menus — baked from frozen to order.",
    image: "/products/savoury.jpg",
    tags: ["frozen", "bake-off", "savoury", "bread", "pastry", "brunch"],
    products: [
      {
        name: "Garlic Cheese Bun",
        desc: "Pillowy enriched bun loaded with garlic butter and melted cheese — ideal for sharing boards.",
        format: "Frozen",
        serves: "Individual",
      },
      {
        name: "Cheese & Herb Focaccia",
        desc: "Olive-oil rich crumb, topped with sea salt, aged cheese and fresh herbs. Bakes golden.",
        format: "Frozen",
        serves: "Portion",
      },
      {
        name: "Spinach & Feta Roll",
        desc: "Flaky, buttery pastry wrapped around a generous filling of wilted spinach and salty feta.",
        format: "Frozen",
        serves: "Individual",
      },
    ],
  },
  {
    id: "oat-mix",
    category: "Overnight Oat Mix",
    index: "06",
    format: "Ambient · Ready-to-hydrate",
    description:
      "A chef-developed overnight oats base built for hotel breakfast buffets and café service. Just add milk or plant-based alternative.",
    image: "/products/oat-mix.jpg",
    tags: ["ambient", "breakfast", "oats", "healthy", "buffet", "hotel"],
    products: [
      {
        name: "Base Mix for Overnight Oats",
        desc: "A ready-to-hydrate premium oat base with seeds and dried fruit — developed for volume service. Customisable with toppings.",
        format: "Ambient",
        serves: "Bulk / Portioned",
      },
    ],
  },
];

// Flat list of all products with their category for search
export const ALL_PRODUCTS = HORECA_CATALOGUE.flatMap((cat) =>
  cat.products.map((p) => ({
    ...p,
    categoryId: cat.id,
    categoryName: cat.category,
    categoryImage: cat.image,
    categoryFormat: cat.format,
    tags: cat.tags,
  }))
);
